import r from"styled-components";import{theme as o}from"../../../../theme.js";const i=r.div`
  display: flex;
  gap: ${o.spacing*2}px;
  align-items: center;
  margin: 0 0 ${o.spacing}px;
  .displayName {
    color: ${o.colors.gray[500]};
    font-size: 12px;
    line-height: 14px;
  }
  .dot {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: ${o.colors.gray[400]};
  }
`;export{i as Container};
